module.exports = "/assets/data/c0fa6c4dd9521e1e502260222311e98e-AB10.data.json";